module.exports = __webpack_public_path__ + "img/siappakai.23edfc21.png";